import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/extranet", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(data);
        // Clear the hash before navigating
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/extranet/tableau-de-bord", { replace: true, state: { user: data } });
      } catch (e) {
        setError("Connexion refusée. Veuillez réessayer.");
        setTimeout(() => navigate("/extranet", { replace: true }), 2000);
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-lin px-6" data-testid="auth-callback">
      <div className="eyebrow mb-4">Briouse</div>
      <div className="font-serif text-2xl text-domaine mb-2">Connexion en cours…</div>
      {error && <div className="text-sm text-destructive mt-4" data-testid="auth-error">{error}</div>}
    </div>
  );
}
